<template>
  <v-overlay :value="show">
    <v-progress-circular
      indeterminate
      size="64"
      width="8"
      color="primary"
    ></v-progress-circular>
  </v-overlay>
</template>

<script>
export default {
  name: 'ModalLoader',
  props: {
    show: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style scoped></style>
